// ==========================================================================
// Singleton for controlling filtering a list
// ==========================================================================

class FilterItems {
  constructor() {
    this.init = this.init.bind(this);
    this.find = this.find.bind(this);
  }

  init() {
    this.items = [...document.querySelectorAll('.js-data-item')];
    this.links = [...document.querySelectorAll('.js-filter-link')];

    this.links.map(link => {
      link.addEventListener('click', event => {
        event.preventDefault();

        this.links.map(link => link.parentElement.classList.remove('active'));
        link.parentElement.classList.add('active');
        this.find(link.getAttribute('data-id'));
      });
    });
  }

  find(id) {
    const filteredItems = [];

    if (id !== '') {
      requestAnimationFrame(() => {
        this.items.map(item => {
          item.classList.remove('filter-matches');
          const ids = item.getAttribute('data-ids').split('-');
          if (ids.includes(id)) filteredItems.push(item);
        });

        filteredItems.map(item => item.classList.add('filter-matches'));
      });
    } else {
      requestAnimationFrame(() =>
        this.items.map(item => item.classList.add('filter-matches')),
      );
    }
  }
}

export default new FilterItems();



// WEBPACK FOOTER //
// ./src/js/filter-items.js